import { ReactNode } from "react";

import { clsx } from "clsx";

import styles from "./NodeSubtext.module.scss";

/**
 * Component to standaradize the sub text blurbs on JB nodes. The styling for combining the antd icons and
 * text and having the look centered is a bit wonky (may be a better way to handle this if soemone looks into
 * it), but seems like the icon + text combo looks best / most accuratley centered with these flex classes
 * in combination with the icon being 1 font size smaller than the text
 *
 * @param icon - antd icon component
 * @param text - any basic value to render (can add to the types if needed this is just what came top of mind)
 *
 * @returns styled subtext component
 */
export function NodeSubtext({ icon, text }: { icon?: ReactNode; text?: Date | string | number }): JSX.Element {
    if (!text && !icon) {
        return <></>;
    }

    const textToDisplay = text instanceof Date ? text.toString() : text;

    return (
        <div className={clsx("flex-row align-center", styles.subtextContainer)}>
            {!!icon && <div className={styles.iconContainer}>{icon}</div>}
            <span>{textToDisplay}</span>
        </div>
    );
}
